module.exports = __webpack_public_path__ + "img/rotate-counterclockwise.86318537.svg";